module.exports = __webpack_public_path__ + "74af2770895a3aa58d2d82dae5279940.pdf";